import styled from "styled-components"

export const CarouselContainerStyled = styled.div`
    margin: auto 0;
    width: 314px;
    height: 143px;
    z-index: 2;
`;

export const SliderContainerStyled = styled.div`
    margin-top: 27px;
`;

export const CarouselCardStyled = styled.div`
    display: flex !important;
    justify-content: center;
`;

export const ImageStyled = styled.img`
    width: 280px;
    height: 45px;
`;

export const CarouselTitleStyled = styled.span`
    font-size: 12px;
    font-weight: 350;
    line-height: 15.6px;
    text-align: center;
    color: #E7EBF0;
`;